"use client";
import { Tarsier } from "../../";
import { useEffect } from "react";

const LoadTarsier = () => {
  useEffect(() => {
    if (Tarsier) {
      const tarsierInstance = Tarsier.init();
      // Attach to window so it can be accessed globally
      (window as Window & { tarsier?: Tarsier }).tarsier = tarsierInstance;
    }
  }, []);
  return <></>;
};

export default LoadTarsier;
